<template>
  <div class="before-apply">
      <van-popup v-model="showNotice" :close-on-click-overlay="false">
        <div class="apply-notice">
          <div class="notice-title">申请须知</div>
          <div class="notice-content">
            您好，为保证本次申请的真实性，以及保护您的个人信息与隐私，让您更好的掌握个人信息的使用情况，我们将根据《中华人民共和国网络安全法》、
            《中华人民共和国个人信息保护法》的相关规定，收集及使用您的个人信息，以及您如何行使您的个人信息权利，请您在仔细阅读并充分理解
            《择美同行-患者援助项目个人信息处理知情同意书》后，自愿选择是否同意参与本项目？
          </div>
          <div class="btns">
            <van-button plain round type="info"  @click.native="toIndex" color="#0AA8AF">退出</van-button>
            <van-button block round type="info"  @click.native="showNotice=!showNotice" color="#0AA8AF">同意</van-button>
          </div>
        </div>
      </van-popup>

      <div class="canvas-title">上传身份证照片</div>

      <div class="idcardupload" >
        <div class="upload-box" :style=BGcolor1>
          <div class="upload-img" @click="showBack=!showBack">
            <div class="upload-img-b" :style="{backgroundImage: 'url('+idcard_back+')'}"></div>
          </div>
        </div>
        <div class="upload-box" :style=BGcolor2>
          <div class="upload-img" @click="showFront=!showFront">
            <div class="upload-img-b" :style="{backgroundImage: 'url('+idcard_front+')'}"></div>
          </div>
        </div>
      </div>

      <div class="text-notice" v-if="showFailNotice">您的身份证已识别失败多次，建议联系项目办：<br/>010-56592455</div>

      <van-popup v-model="showFront" :close-on-click-overlay="true">
        <div class="apply-notice">
          <div class="notice-title">身份证国徽面</div>
          <div class="notice-content2">
            <div class="oneLine"><div class="dot"></div>请将身份证放置于桌面，确保无杂乱背景</div>
            <div class="oneLine"><div class="dot"></div><div>您需确保拍摄卡面无反光、对焦清晰</div></div>
            <div class="oneLine"><div class="dot"></div><div>请勿使用复印件翻拍</div></div>
            <div class="oneLine canter"><img style="width:200px;height:121px;" src="/static/id_back.png" /></div>
          </div>
            <van-button block round type="info"  @click.native="chooseImage('front')" color="#0AA8AF">确认并上传</van-button>
        </div>
      </van-popup>
      <van-popup v-model="showBack" :close-on-click-overlay="true">
        <div class="apply-notice">
          <div class="notice-title">身份证人像面</div>
          <div class="notice-content2">
            <div class="oneLine"><div class="dot"></div>请将身份证放置于桌面，确保无杂乱背景</div>
            <div class="oneLine"><div class="dot"></div><div>您需确保拍摄卡面无反光、对焦清晰</div></div>
            <div class="oneLine"><div class="dot"></div><div>请勿使用复印件翻拍</div></div>
            <div class="oneLine canter"><img style="width:200px;height:121px;" src="/static/id_front.png" /></div>
          </div>
            <van-button block round type="info"  @click.native="chooseImage('back')" color="#0AA8AF">确认并上传</van-button>
        </div>
      </van-popup>

      <div class="btn">
        <van-button block round type="info" :disabled="idcardBtnDisabled" @click.native="nextStep" color="#0AA8AF">提交</van-button>
      </div>

  </div>

</template>

<script>
  import {
    checkin,
    UploadContract,
    IdcardOcr
  } from "../../api/api";
  import { DownloadImage } from "../../api/patient";
  import {
    mapState
  } from "vuex";
  import Vue from "vue";
  import {
    Toast,
    Dialog
  } from "vant";
  import idcard_front from "@/assets/upload-id1.png";
  import idcard_back from "@/assets/upload-id2.png";
import { isPCWechat } from "@/utils/utils";

  let hostname = window.location.hostname
  hostname = hostname.substring(hostname.indexOf('.'))
  let baseUrl = window.location.protocol + '//api' + hostname;

  Vue.use(Toast);
  Vue.use(Dialog);

  export default {
    data() {
      return {
        showNotice:true,
        showFront: false,
        showBack:false,
        showFailNotice:false,

        idcard_front: idcard_front,
        idcard_back: idcard_back,
        patient_id: "",
        reason: "",
        status: "",
        showUploadIdcard: false,
        signature_image: "",
        idcards: [{
            image: "",
            type: "人像面"
          },
          {
            image: "",
            type: "国徽面"
          }
        ],
        submitBtnDisabled: false,
        idcardBtnDisabled: false,
      };
    },
    computed: {
      ...mapState(['patientOne', 'userInfo']),
      BGcolor1(){
        let color=''
        let str="background:"
        if(!(this.idcard_back === idcard_back)){ 
          color="#F6F6F6;"
          str+=color
          console.log("BGcolor1",str)
          return str
        }else{
          return ''
        }
        
      },
      BGcolor2(){
        let color=''
        let str="background:"
        if(!(this.idcard_front === idcard_front)) {
          color="#F6F6F6;"
          str+=color
          console.log("BGcolor2",str)
          return str
        }else{
          return ''
        }
      },
    },
    async created() {
      this.patient_id = this.$route.query.patientid;
      // this.reason = this.$route.query.reason;
      // this.status = this.$route.query.status;
      // if (this.status) {
      //   Dialog.alert({
      //     title: '知情同意书签名' + this.status,
      //     message: '原因：' + this.reason + '<br/>请重新签名!',
      //   }).then(() => {
      //     // on close
      //   });
      // }
      if (this.patientOne) {
        if (this.patientOne.signature_image && this.status != '未上传') this.signature_image = this.patientOne.signature_image
        if (this.patientOne.idcard_front) {
          this.idcard_back = this.patientOne.idcard_front
          this.idcards[1].image = this.patientOne.idcard_front
        }
        if (this.patientOne.idcard_back) {
          this.idcard_front = this.patientOne.idcard_back
          this.idcards[0].image = this.patientOne.idcard_back
        }
      }
    },
    mounted() {

    },
    methods: {
      chooseImage(side) {
        if (isPCWechat()) {
          console.log('请使用手机端微信进行拍照上传')
          Toast("请使用手机端微信进行拍照上传");
          return false;
        }
        if(side=="front") this.showFront=!this.showFront
        if(side=="back") this.showBack=!this.showBack
        
        this.wx.chooseImage({
          count: 1,
          sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
          sourceType: ["camera"], // ["album", "camera"] 可以指定来源是相册还是相机，默认二者都有
          success: async res => {
            try {
              const serverId = res.localIds[0];
              await this.uploadImage(serverId, side);
            } catch (err) {
              Toast(err.response.data.message);
            }
          },
          fail: function () {
            Toast("选图失败");
          }
        });
      },
      uploadImage(serverId, side) {
        return new Promise((resolve, reject) => {
          this.wx.uploadImage({
            localId: serverId,
            isShowProgressTips: 1,
            success: res => {
              var serverId = res.serverId; // 返回图片的服务器端ID
              Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true
              });
              DownloadImage({
                  params: {
                    serverId: serverId
                  }
                })
                .then(res => {
                  if (side === "back") {
                    this.idcard_back = this.checkImg(res.data);
                    this.idcards[0].image = this.checkImg(res.data);
                    // this.idcards[0].image = 'https://papkmbzayyc.ilvzhou.com/statics/upload/attachment/202003/05/e49a13704664b2bca22fe97a2358c9ee.jpg'
                  } else {
                    this.idcard_front = this.checkImg(res.data);
                    this.idcards[1].image = this.checkImg(res.data);
                    // this.idcards[1].image = 'https://papkmbzayyc.ilvzhou.com/statics/upload/attachment/202003/05/d6593ba20a7a265a641e7fb19897314f.jpg'
                  }
                  // console.log('uploadImage', this.idcards)
                  Toast.clear();
                  resolve();
                })
                .catch(err => {
                  Toast.clear();
                  reject(err.response.data.message);
                });
            },
            fail: function () {
              Toast("图片上传失败");
            }
          });
        });
      },
       checkImg(img) {
      var url = img;
      if(img.indexOf('http') == -1) {
        url = this.baseUrl + img
      }
      return url
    },
      nextStep() {
        if (
          this.idcard_front === idcard_front ||
          this.idcard_back === idcard_back
        ) {
          Toast("请上传图片");
          return false;
        }
        Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true
        });
        this.idcardBtnDisabled = true;
        const reqData = {};
        reqData.patient_id = this.patient_id;
        reqData.idcards = this.idcards;
        // console.log(reqData, this.idcards)
        IdcardOcr(reqData)
          .then(res => {
            Toast.clear();
            this.idcardBtnDisabled = false;
            console.log(res)
            if(res.data.count>2) this.showFailNotice=true;
            if(res.data.status){
              this.$router.replace({
                name: "Blank"
              });
              return
            }else{
              console.log("IdcardOcr-res.status:",res.status);
              Dialog.alert({
                message: res.data.message,
              })
            }
          })
          .catch(err => {
            this.idcardBtnDisabled = false;
            Toast.clear();
            Dialog.alert({
              message: err.response.data.message,
            })
          });
      },

      toIndex() {
        this.$wechat.closeWindow()
      },

      goPage(pageName){
        this.$router.replace({name: pageName})
      }
    }
  };
</script>
<style lang='less'>
  .before-apply {
    // margin: 0 5%;
    text-align: center;
    // padding-bottom: 74px;
    min-height: 100vh;
    box-sizing: border-box;
    position: relative;

    .canvas-title {
      height: 48px;
      line-height: 48px;
      font-size: 1.6rem;
      position: relative;

      &::after {
        .b-line;
      }
    }

//TODO:删减上面的
    .idcardupload {
      padding: 15px 30px;
      min-height: 70vh;
      .upload-box .upload-img {
        // height: 150px;
        max-width: 480px;
        max-height: 300px;
        background-image: none;
        background-position:5px 5px;
        border-radius: 6px;
        padding: 0 ;
        // margin-bottom: 40px;
        .upload-img-b {
          background-color: transparent; 
          box-shadow: 0 0 20px transparent; 
        }
      }
    }
    .text-notice{
      color:red;
      text-align: center;
      margin: 15px;
      font-size: 13px;
    }



    button.van-button.van-button--info.van-button--normal.van-button--block.van-button--round {
      box-shadow: 0 0 3px @main-green;
    }
    .van-popup.van-popup--center {
      width: 80%;
    }
    .apply-notice{
      margin: 20px;
      .notice-title{
        font-size: 20px;
      }
      .notice-content{
        text-indent:25px;
        text-align: left;
        font-size:14px;
        margin: 20px 0;
      }
      .notice-content2{
        text-align: left;
        font-size:14px;
        margin: 20px 0;
        .oneLine{
          display:flex;
          color:#8FA0AA ;
          .dot{
            flex:0 0 auto;
            margin: 7px ;
            width: 5px;
            height: 5px;
            background-color: rgba(255, 0, 0, 0.253);
            border:1px solid rgba(255, 0, 0, 0.564);
            border-radius: 50%;
          }
        }
      }
      .btns{
        display: flex;
        justify-content:space-around;
        button.van-button--round {
          width: 90px;
        }
      }
    }
    .van-row{
      margin:0 10px;
    }



    .btn{
      // position: absolute;
      // bottom:20px;
      margin-bottom: 20px;
      display: flex;
      justify-content:space-around;
      button.van-button--round {
        // width: 90px;
        margin: 0 20px ;
      }
    }
    .canter{
      margin-top: 10px;
      justify-content:center;
    }
    .van-popup{
      border-radius: 6px;
    }
    .van-popup--center {
      top: 45%;
    }
    .van-overlay {
      background-color: fade(#000, 60%);
    }
  }
</style>